<template>
    <popup-overlay>
        <popup-wrapper>
            <div class="cz2__modal-popup--tos">
                <div class="cz2__modal-popup__header text-base text-base lg:text-2xl lg:tracking-loose cz2__tos__header mb-4">
                    {{$t('TOS_HEADER')}}

                    <button class="modal-popup__close" :aria-lable="$t('POPUP_CLOSE')" @click.prevent="close">
                    </button>
                </div>

                <div class="cz2__tos__warning text-left">
                    {{$t('TOS_WARNING')}}
                </div>

                <div class="cz2__tos__accept text-left mt-8 mb-8">
                    <label class="cz2__tos-accept__label" for="tos__accepted">
                        <input type="checkbox" id="tos__accepted" v-model="accepted">

                        {{$t('TOS_CHECKBOX')}}
                    </label>
                </div>

                <div class="cz2__tos-conditions text-left">
                    <p class="mb-2" v-html="$t('TOS_LINE1')"></p>
                    <p class="mb-2" v-html="$t('TOS_LINE2')"></p>
                    <p class="mb-2" v-html="$t('TOS_LINE3')"></p>
                    <p class="mb-2" v-html="$t('TOS_LINE4')"></p>
                    <p class="mb-2" v-html="$t('TOS_LINE5')"></p>
                </div>
            </div>
        </popup-wrapper>
    </popup-overlay>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__modal-popup--tos {
            @include respond-below(sm) {
                height: 70vh;

                overflow: auto;

                -webkit-overflow-scrolling: touch;
            }

            .cz2__tos__header {
                color: #c01d1d;
            }

            .cz2__tos-accept__label {
                flex: 1 1 auto;

                cursor: pointer;

                font-weight: bold;

                input {
                    appearance: auto !important;

                    margin-right: 10px;
                }
            }
        }
    }
</style>

<script>
    import PopupOverlay from './PopupOverlay.vue';
    import PopupWrapper from './PopupWrapper.vue';

    export default {
        components: {
            PopupOverlay,
            PopupWrapper,
        },
        data() {
            return {
                accepted: false,
            };
        },
        watch: {
            accepted() {
                if (this.accepted) {
                    this.confirm();
                }
            },
        },
        methods: {
            close() {
                this.$store.dispatch('showTosConfirmation', null);
            },
            confirm() {
                this.$store.dispatch('showTosConfirmation', null);
                this.$store.dispatch('tosConfirmed');
            },
        },
    };
</script>
